var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('jumbotron'),_c('user-articles'),_c('new-articles'),_c('articles-on-sales')],1),_c('highlihgted-categories'),_c('div',{staticClass:"container"},[_c('home-banner')],1),_c('mobile-app'),_c('top-brands')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }